import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var SortDownIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 6 15" }),
        React.createElement("path", { d: "M3.90676 10.9332V0.910342C3.90676 0.409654 3.49711 0 2.99642 0C2.49573 0 2.08608 0.409654 2.08608 0.910342V10.9332H0.456568C0.0469142 10.9332 -0.153361 11.4248 0.137948 11.707L2.6778 14.2378C2.85987 14.4107 3.14208 14.4107 3.32415 14.2378L5.864 11.707C6.15531 11.4248 5.94593 10.9332 5.54538 10.9332H3.90676Z" })));
};

export { SortDownIcon };
//# sourceMappingURL=SortDownIcon.esm.js.map
